// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import { ListItemText } from '@mui/material';
// import HouseIcon from '@mui/icons-material/House';
// import PersonIcon from '@mui/icons-material/Person';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
// import NoteIcon from '@mui/icons-material/Note';
// import Hidden from '@mui/material/Hidden'; // Use Material UI's Hidden component
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import ReplyIcon from '@mui/icons-material/Reply';
// import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
// import SyncIcon from '@mui/icons-material/Sync';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ReceiptIcon from '@mui/icons-material/Receipt';

// const Home = () => {
//     const cardStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '5px',
//         margin: '10px',
//         backgroundColor: '#fff',
//         borderRadius: '12px',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         textDecoration: 'none',
//         color: 'inherit',
//         width: '35%',
//         minHeight: '50px',
//     };

//     const MastercardStyle = {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '5px',
//         margin: '10px',
//         backgroundColor: '#fff',
//         borderRadius: '12px',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         textDecoration: 'none',
//         color: 'black',
//         width: '40%',
//         minHeight: '20px',
//     };

//     const containerStyle = {
//         display: 'flex',
//         flexWrap: 'wrap',
//         justifyContent: 'center',
//         padding: '20px',
//         backgroundColor: '#FBF9F1',
//         marginTop: '0px'
//     };



//     return (
//         <div>
//             <Hidden mdUp>
//                 <div>

//                     <div className="bg-white p-6 rounded-lg shadow-lg" style={containerStyle}>

//                         <NavLink to="/MasterIndex" style={MastercardStyle}>
//                             <PersonIcon style={{ color: 'black' }} />
//                             <ListItemText primary="Registration" />
//                         </NavLink>
//                     </div>
//                     <div className="bg-white p-6 rounded-lg shadow-lg" style={containerStyle}>
//                         <NavLink to="/ExpenseCreate" style={MastercardStyle}>
//                             <ArrowBackIcon style={{ color: '#ED7D31' }} />
//                             <ListItemText primary="Expense" />
//                         </NavLink>
//                     </div>
//                     <div className="bg-white p-6 rounded-lg shadow-lg" style={containerStyle}>
//                         <NavLink to="/IncomeCreate" style={MastercardStyle}>
//                             <ArrowForwardIcon style={{ color: 'darkolivegreen' }} />
//                             <ListItemText primary="Income" />
//                         </NavLink>
//                     </div>
//                     <div className="bg-white p-6 rounded-lg shadow-lg" style={containerStyle}>
//                         <NavLink to="/ReceiptCreate" style={MastercardStyle}>
//                             <ReceiptIcon style={{ color: 'darkolivegreen' }} />
//                             <ListItemText primary="Receipt" />
//                         </NavLink>
//                     </div>

//                 </div>
//             </Hidden>
//         </div>
//     );
// };

// export default Home;


// import { NavLink } from 'react-router-dom';
// import { Hidden, ListItemText } from '@mui/material';
// import PersonIcon from '@mui/icons-material/Person';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import { useState, useEffect } from 'react';

// // Animation styles for card entrance
// const fadeInAnimation = (delay) => ({
//   opacity: 0,
//   transform: 'translateY(20px)',
//   animation: `fadeIn 0.8s ${delay}s forwards`,
// });

// // Keyframe animation (add this to your CSS)
// const keyframes = `
//   @keyframes fadeIn {
//     0% {
//       opacity: 0;
//       transform: translateY(20px);
//     }
//     100% {
//       opacity: 1;
//       transform: translateY(0);
//     }
//   }
// `;

// // Inject keyframes into the page
// const addGlobalStyle = () => {
//   const style = document.createElement('style');
//   style.innerHTML = keyframes;
//   document.head.appendChild(style);
// };

// const cardContainerStyle = {
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   justifyContent: 'center',
//   width: '100%',
//   maxWidth: '280px',
//   margin: '10px auto',
//   padding: '30px',
//   borderRadius: '15px',
//   boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
//   transition: 'transform 0.4s ease, box-shadow 0.4s ease',
//   cursor: 'pointer',
//   color: 'white',
// };

// const mastercardStyle = {
//   textDecoration: 'none',
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   gap: '12px',
//   fontSize: '20px',
//   fontWeight: 'bold',
//   textAlign: 'center',
// };

// const hoverEffect = {
//   transform: 'scale(1.08)',
//   boxShadow: '0px 12px 28px rgba(0, 0, 0, 0.2)',
// };

// const Card = ({ to, icon: Icon, label, background, delay }) => (
//   <div
//     className="card"
//     style={{ ...cardContainerStyle, backgroundImage: background, ...fadeInAnimation(delay) }}
//     onMouseEnter={(e) => (e.currentTarget.style = { ...cardContainerStyle, ...hoverEffect })}
//     onMouseLeave={(e) => (e.currentTarget.style = cardContainerStyle)}
//   >
//     <NavLink to={to} style={mastercardStyle}>
//       <Icon style={{ fontSize: '48px' , color:'white'}} />
//       <ListItemText primary={label}  style={{ fontSize: '48px' , color:'white'}}/>
//     </NavLink>
//   </div>
// );

// const Home = () => {
//   useEffect(() => addGlobalStyle(), []); // Inject keyframes on component mount

//   return (
//     <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px', padding: '20px' }}>
//       <Hidden mdUp>
//         <Card 
//           to="/MasterIndex" 
//           icon={PersonIcon} 
//           label="Registration" 
//           background="linear-gradient(135deg, #6a11cb, #2575fc)" 
//           delay={0} 
//         />
//         <Card 
//           to="/ExpenseCreate" 
//           icon={ArrowBackIcon} 
//           label="Expense" 
//           background="linear-gradient(135deg, #f7971e, #ffd200)" 
//           delay={0.1} 

//         />
//         <Card 
//           to="/IncomeCreate" 
//           icon={ArrowForwardIcon} 
//           label="Income" 
//           background="linear-gradient(135deg, #00c6ff, #0072ff)" 
//           delay={0.2} 

//         />
//         <Card 
//           to="/ReceiptCreate" 
//           icon={ReceiptIcon} 
//           label="Receipt" 
//           background="linear-gradient(135deg, #ff758c, #ff7eb3)" 
//           delay={0.3} 

//         />
//       </Hidden>
//     </div>
//   );
// };

// export default Home;


import { NavLink } from 'react-router-dom';
import { Hidden, ListItemText } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useEffect } from 'react';

// Animation styles for card entrance
const fadeInAnimation = (delay) => ({
    opacity: 0,
    transform: 'translateY(20px)',
    animation: `fadeIn 0.8s ${delay}s forwards`,
});

// Keyframes for animations
const keyframes = `
  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Injecting the keyframes into the page's style
const addGlobalStyle = () => {
    const style = document.createElement('style');
    style.innerHTML = keyframes;
    document.head.appendChild(style);
};

const cardContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '280px',
    margin: '10px auto',
    padding: '30px',
    borderRadius: '15px',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.4s ease',
    backgroundSize: 'cover',
    color: 'white',
    cursor: 'pointer',
};

const mastercardStyle = {
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '7px',
    fontSize: '20px',
    fontWeight: 'bold',
    textAlign: 'center',
};

// Card Component without hover effects
const Card = ({ to, icon: Icon, label, background, delay }) => (
    <div
        className="card"
        style={{ ...cardContainerStyle, backgroundImage: background, ...fadeInAnimation(delay) }}
    >
        <NavLink to={to} style={mastercardStyle}>
            <Icon style={{ fontSize: '48px', color: 'black' }} />
            <ListItemText primary={label} style={{ fontSize: '24px', color: 'black' }} />
        </NavLink>
    </div>
);

const Home = () => {
    useEffect(() => addGlobalStyle(), []); // Inject keyframes on component mount

    return (
        

        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px', padding: '20px' }}>
            <Hidden mdUp>
                <Card
                    to="/MasterIndex"
                    icon={PersonIcon}
                    label="REGISTRATION"
                    background="linear-gradient(135deg, #98FB98, #F0FFF0)" // Mint and creamy green theme
                    delay={0}
                />
                <Card
                    to="/ExpenseCreate"
                    icon={ArrowBackIcon}
                    label="EXPENSE"
                    background="linear-gradient(135deg, #98FB98, #F0FFF0)" // Mint and creamy green theme
                    delay={0.1}
                />
                <Card
                    to="/IncomeCreate"
                    icon={ArrowForwardIcon}
                    label="INCOME"
                    background="linear-gradient(135deg, #98FB98, #F0FFF0)" // Mint and creamy green theme
                    delay={0.2}
                    
                />
                <Card
                    to="/ReceiptCreate"
                    icon={ReceiptIcon}
                    label="RECEIPT"
                    background="linear-gradient(135deg, #98FB98, #F0FFF0)" // Mint and creamy green theme
                    delay={0.3}
                />
            </Hidden>
        </div>

    );
};

export default Home;
